import { useNavigate } from 'react-router-dom';
import { Button, Input, InputWrapperAuth } from '@/components/ui';
import { z } from 'zod';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { CircleArrowLeft, Lock, Mail } from 'lucide-react';
import { UserWelcomeContainer } from '@/pages/user';

const schema = z
	.object({
		password: z
			.string()
			.min(6, 'A senha deve ter no mínimo 6 caracteres')
			.max(255, 'A senha deve ter no máximo 255 caracteres')
			.regex(
				/^[0-9A-Za-zÀ-ÖØ-öø-ÿ!@#$%^&*()_+\-= [\]{};':"\\|,.<>/?~`]+$/,
				'A senha contém caracteres inválidos',
			)
			.regex(
				/^(?=.*[A-Za-z])(?=.*\d).+$/,
				'A senha deve conter pelo menos uma letra e um número',
			),
		repeat_password: z.string(),
	})
	.refine((data) => data.password === data.repeat_password, {
		message: 'As senhas não coincidem',
		path: ['repeat_password'],
	});

type FormData = z.infer<typeof schema>;

const Recover = () => {
	const navigate = useNavigate();

	const {
		register,
		handleSubmit,
		watch,
		formState: { errors },
	} = useForm<FormData>({
		resolver: zodResolver(schema),
	});

	const iconCommonClass = 'w-4 h-4 text-zinc-500';

	const onSubmit = async (data: FormData) => {
		console.log(data);
		navigate('/recuperar-senha/codigo');
	};

	return (
		<form
			onSubmit={handleSubmit(onSubmit)}
			className="flex h-full w-full flex-col items-center justify-center space-y-6 overflow-hidden overflow-y-auto px-4 py-6 md:w-1/2 md:max-w-none md:space-y-8 md:p-4"
		>
			<UserWelcomeContainer
				title="Recuperar senha"
				subtitle="Crie uma nova senha"
			/>
			<div className="mx-auto flex w-full max-w-96 flex-col gap-4">
				<div>
					<InputWrapperAuth
						label="Senha"
						icon={<Lock className={iconCommonClass} />}
						error={errors.password?.message}
						value={watch('password')}
						displayError
					>
						<Input
							type="password"
							{...register('password')}
							placeholder="********"
						/>
					</InputWrapperAuth>
				</div>
				<div>
					<InputWrapperAuth
						label="Repita a senha"
						icon={<Lock className={iconCommonClass} />}
						error={errors.repeat_password?.message}
						value={watch('repeat_password')}
						displayError
					>
						<Input
							type="password"
							{...register('repeat_password')}
							placeholder="********"
						/>
					</InputWrapperAuth>
				</div>
			</div>
			<Button
				className=" w-full max-w-96 justify-center rounded-lg py-2"
				text="Concluir"
				endIcon={
					<Mail className="h-fit w-4 text-light transition-all ease-in group-hover:translate-x-1" />
				}
			/>
			<div className="mx-auto w-96">
				<Button
					startIcon={<CircleArrowLeft className="size-4 text-dark" />}
					variant="text"
					text="voltar"
					className="w-fit justify-center self-start text-base"
					onClick={() => navigate(-1)}
				/>
			</div>
		</form>
	);
};

export { Recover };
